export const errorHandlingRule = {
  id: 'error-handling',
  name: 'Error Handling',
  description: 'If aderror fires, it should include a valid VAST error code',

  check(session) {
    const errors = session.events.filter(e => e.type === 'aderror');

    if (errors.length === 0) {
      return { status: 'na', message: 'No errors occurred during this session' };
    }

    const withCode = errors.filter(e => e.data?.code != null && e.data.code !== -1);
    if (withCode.length === 0) {
      return {
        status: 'fail',
        message: `${errors.length} error(s) fired but none had a valid VAST error code`,
      };
    }

    if (withCode.length < errors.length) {
      return {
        status: 'fail',
        message: `${errors.length - withCode.length} error(s) missing VAST error code`,
      };
    }

    const codes = withCode.map(e => e.data.code).join(', ');
    return {
      status: 'pass',
      message: `${errors.length} error(s) with valid codes: ${codes}`,
    };
  },
};
